import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const CdtDetailContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.white};
`;

export const CdtDetailWrapper = styled.div`
  margin-bottom: 30px;
`;

export const CdtDetailHeader = styled.div``;

export const CdtDetailHaderGrid = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CdtDetailHaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
  text-transform: uppercase;
`;

export const CdtDetailSelectShowOptionSelectContent = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

export const CdtDetailSelectShowOptionLabel = styled.span`
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  text-transform: uppercase;
`;

export const CdtDetailSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const CdtDetailSelectShowOptionSelect = styled.div`
  margin-top: 5px;
  width: 100%;
  max-width: 210px;
  position: relative;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  svg {
    transform: ${prop => prop.open ? 'none' : 'rotate(180deg) !important'};
    transition: ease-in-out .2s;
  }
`;

export const CdtDetailSelectShowOptionSelected = styled.span`
  font-size: 14px;
  color: ${colors.bgPrimary};
  line-height: 20px;
  text-align: right;
  margin-right: 10px;

  &.default {
    color: ${colors.textSecondary};
    margin-right: 0px;
  }
`;



export const CdtDetailContent = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: 260px 1fr;
`;

export const CdtDetailSteps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: end;
`;

export const CdtDetailStepsStatus = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 10px; 
  }
`;

export const CdtDetailStepsStepCircle = styled.div`
  min-width: 50px;
  min-height: 50px;
  border-radius: 25px;
  border: 2px solid ${prop => prop.finish ? colors.bgPrimaryLight : prop.active ? colors.bgPrimaryLight : colors.grayLight};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.finish ? colors.bgPrimaryLight : prop.active ? colors.white : colors.grayLight};
  color: ${prop => prop.active ? colors.bgPrimaryLight : colors.white};
  font-weight: 600;
`;

export const CdtDetailStepsLabel = styled.span`
  margin-right: 29px;
`;

export const CdtDetailStepsStatusBar = styled.div`
  width: 2px;
  height: 40px;
  background: ${prop => prop.finish ? colors.bgPrimaryLight : colors.grayLight};
  margin-right: 25px;
`;

export const CdtDetailSelectLabel = styled.span`
  text-transform: uppercase;
  color: ${colors.textPrimary};
  font-size: 12px;
  line-height: 14px;
  text-align: right;
`;

export const CdtDetailSelectShowOptionSelectedMessageError = styled.div`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 0px;
  opacity: ${prop => prop.error ? '1' : '0'};
  transition: ease-in-out .2s;
`;

export const CdtDetailSelectActiveOption = styled.span`
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  font-size: 16px;
  line-height: 23px;
`;
export const CdtHeaderIcon = styled.div`
  width: 35px;
  height: 35px;
  background: ${colors.bgTertiary};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
`;

export const CdtMainDetail = styled.div`
  font-size: 10px;
  font-weight: bold;
  align: right;
`;

export const CdtBoxDetailContent = styled.div`
  background-color: ${colors.grayLight};
  border-radius: 5px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  clear:both;
  margin: 8px;
  padding: 8px;
flex-direction:column;
  & + & {
    margin: 8px 0;
  }
`;

export const CdtDetailBodyGrid = styled.div`
  display: flex;
  justify-content: space-between;
  

  & + & {
    margin: 8px 0;
  }
`;

export const CdtDetailBodyLabel = styled.span`
  color: ${colors.textPrimary};
  font-size: 12px;
  line-height: 23px;
  width:50%;
  float:left;
`;

export const CdtDetailBodyValue = styled.span`
  color: ${colors.textPrimary};
  font-size: 12px;
  line-height: 23px;
  width:50%;
  float:right;
  text-align:right;
  vertical-align: top;
`;

export const CdtDetailHeaderGrid = styled.div`
  display: flex;
  flex-direction:row;
  

  & + & {
    margin: 8px 0;
  }
`;

export const CdtDetailBodyLine = styled.div`
display: flex;
flex-direction:row;


& + & {
  margin: 8px 0;
}
`;

export const CdtDetailFinishedContent = styled.div`
display: flex;
flex-direction:column;
`;

export const CdtDetailSubTitle = styled.div`
font-weight: bold;
font-size: 14px;
color: ${colors.darkblue}
`;

export const CdtDetailHalfBox = styled.div`
background-color: ${colors.gamerGray};
  border-radius: 5px;
  font-size: 12px;
  width: 50%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  clear:both;
  vertical-align:top;
  text-align:center;
  margin: 8px;
  padding: 8px
flex-direction:column;
  & + & {
    margin: 8px 0;
  }
`;

export const CdtBoxDetailFinishedContent = styled.div`
  background-color: ${colors.gamerGray};
  border-radius: 5px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-shadow: 1px 10px 12px 0px rgba(0,0,0,0.38);
  clear:both;
  margin: 8px;
  padding: 8px;
flex-direction:column;
  & + & {
    margin: 8px 0;
  }
`;

export const CdtDetailFooter = styled.div`
  border-top: 1px solid ${colors.textExGrayLight};
  display: flex;
  flex-direction: column;
  padding: 8px 15px;
`;

export const CdtDetailFooterLabel = styled.div`
  color: ${colors.textPrimary};
  font-size: 10px;  
  line-height: 23px;
`;

export const CdtDetailFooterPrice = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CdtDetailFooterValue = styled.span`
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin-top: 10px;
`;

export const CdtDetailFooterValueInfo = styled.span`
  font-size: 14px;
  color: ${colors.textPrimary};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;